import { stats } from '@/mocks/homeMocks';

export default function StatsSection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <p className="text-3xl md:text-4xl font-heading font-bold text-primary-500">{stat.value}</p>
              <p className="mt-1 text-sm text-foreground-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}